const keys = {
  all: ['companies'],
  company: id => [...keys.all, { companyId: parseInt(id, 10) }],
  companyUsers: id => [...keys.all, 'users', { companyId: id }],
  companyActiveUsers: id => [...keys.all, 'users', { companyId: id }, 'active'],
  companyFeatures: id => [...keys.all, 'features', { companyId: id }],
  companyCustomRoles: (id, params) => [...keys.all, 'custom_roles', { companyId: id }, params],
  companyPermissions: id => [...keys.all, 'permissions', { companyId: id }],
  companyAllPolicyTypes: id => [...keys.all, 'policy_types', { companyId: id }, 'all'],
  companyAllDocumentTypes: id => [...keys.all, 'document_types', { companyId: id }, 'all'],
  companyItemTypes: id => [...keys.all, 'item_types', { companyId: id }],
  companyCodes: id => [...keys.all, 'codes', { companyId: id }],
  companyInsuranceCompanies: (id, params) => [...keys.all, 'insurance_companies', { companyId: id, filter: params?.filter }],
  companyInsuredsList: (id, params) => [...keys.all, 'insureds', { companyId: id }, params],
  companyIdFromProcoreCompanyId: procoreCompanyId => [...keys.all, 'procore-company-id', { procoreCompanyId: parseInt(procoreCompanyId, 10) }],
  companyRequirementTemplateFolders: id => [...keys.all, 'requirement-template-folders', { companyId: parseInt(id, 10) }],
  companyQuestionCategoryBase: id => [...keys.company(id), 'question-categories'],
  companyQuestionCategories: (id, filters) => [...keys.companyQuestionCategoryBase(id), { filters }]
};

export default keys;
